import React from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Alert
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';

const Step4View: React.FC = () => {
    const { formulario } = useFormularioSecretariaMunicipalAgriculturaStore();

    if (!formulario) {
        return (
            <Box display="flex" justifyContent="center" p={3}>
                <Typography>Carregando informações...</Typography>
            </Box>
        );
    }

    return (
        <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
            <Typography variant="h5" gutterBottom color="primary">
                Serviços Prestados
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="body1" color="textSecondary" gutterBottom>
                        Relação dos serviços prestados pela Secretaria/Órgão Municipal de Agricultura:
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    {formulario.servicos_prestados_descritivo && formulario.servicos_prestados_descritivo.length > 0 ? (
                        <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f8f9fa' }}>
                            <List>
                                {formulario.servicos_prestados_descritivo.map((servicoItem, index) => (
                                    <ListItem key={index} sx={{ py: 0.5 }}>

                                        <ListItemText
                                            primary={servicoItem.servicos_prestados_orgao_agricultura.nome_servico}
                                            primaryTypographyProps={{
                                                variant: 'body1',
                                                fontWeight: 500
                                            }}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </Paper>
                    ) : (
                        <Alert severity="info">
                            <Typography variant="body2">
                                Nenhum serviço prestado foi informado para esta secretaria/órgão.
                            </Typography>
                        </Alert>
                    )}
                </Grid>

                {formulario.servicos_prestados_descritivo && formulario.servicos_prestados_descritivo.length > 0 && (
                    <Grid item xs={12}>
                        <Box sx={{ mt: 2, p: 2, backgroundColor: '#e3f2fd', borderRadius: 1 }}>
                            <Typography variant="body2" color="primary" fontWeight="bold">
                                Total de serviços prestados: {formulario.servicos_prestados_descritivo.length}
                            </Typography>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Paper>
    );
};

export default Step4View; 